// The food Arlo's breeder feeds him (Mole Valley Farmers' own brand). Keep him
// on it at first; the feeding chart and calories are on the bag.

export const BREEDER_FOOD = {
  brand: 'Country Dog',
  product: 'Premium Puppy Hypoallergenic Chicken & Rice',
  link: 'https://www.moleonline.com/country-dog-premium-puppy-hypoallergenic-chicken-rice-dry-puppy-food-10kg-1154861',
  /** From the maker's listing. */
  protein: '32% protein, 37% chicken; no added wheat, soya or dairy',
};
